import script from "./terms.of.use.modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./terms.of.use.modal.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__